import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="inicio" className="bg-brand-charcoal pt-24 pb-10 md:pt-32 md:pb-16 px-4 relative overflow-hidden" data-id="element-67">
      {/* Background glow effect */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-brand-orange/10 rounded-full blur-[120px] pointer-events-none" data-id="element-68" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-69">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-70">
          {/* Badge */}
          <motion.div variants={itemVariants} className="mb-4" data-id="element-71">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-orange/10 text-brand-orange border border-brand-orange/30 text-xs sm:text-sm font-semibold tracking-wide whitespace-nowrap" data-id="element-72">
              ⭐ La Fuente #1 de Leads para el Mercado Hispano
            </span>
          </motion.div>

          {/* Headline */}
          <motion.h1 variants={itemVariants} className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight md:leading-tight mb-6 text-balance" data-id="element-73">
            Los Leads de Seguros Que{' '}
            <span className="text-brand-orange" data-id="element-74">Más Convierten</span> en el
            Mercado Hispano
          </motion.h1>

          {/* Video Embed */}
          <motion.div variants={itemVariants} className="relative w-full max-w-4xl mx-auto aspect-video rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10 mb-8" data-id="element-75">
            <iframe src="https://player.vimeo.com/video/1141699464?title=0&byline=0&portrait=0" className="absolute top-0 left-0 w-full h-full" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen loading="lazy" title="Presentación Xclusive Agent Leads" data-id="element-76" />
          </motion.div>

          {/* CTAs - side by side */}
          <motion.div variants={itemVariants} className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full sm:w-auto px-2" data-id="element-77">
            <a href="#agendar" className="w-full sm:w-auto bg-brand-orange hover:bg-orange-500 text-white px-6 py-3 md:px-8 md:py-4 rounded-lg font-bold text-sm md:text-lg transition-all shadow-lg shadow-brand-orange/20 hover:shadow-brand-orange/40 flex items-center justify-center gap-2 text-center" data-id="element-78">
              Agendar una llamada <span aria-hidden="true" data-id="element-79">→</span>
            </a>
            <a href="#como-funciona" className="w-full sm:w-auto bg-transparent border-2 border-white/20 hover:border-white text-white px-6 py-3 md:px-8 md:py-4 rounded-lg font-bold text-sm md:text-lg transition-all flex items-center justify-center gap-2 text-center" data-id="element-80">
              Ver cómo funciona <span aria-hidden="true" data-id="element-81">↓</span>
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}